import {CHANGE_PASSWORD_EVENTS} from './ChangePasswordEvents';
import {FORGOT_PASSWORD_EVENTS} from './ForgotPasswordEvents';
import {PASSWORD_STATE_EVENTS} from './PasswordStateEvents';
import {RESET_PASSWORD_EVENTS} from './ResetPasswordEvents';
import {PASSWORD_SERVICES_EVENTS} from './ServicesEvents';
import {SET_UP_PASSWORD_EVENTS} from './SetUpPasswordEvents';

export const PASSWORD_EVENTS = {
  ...PASSWORD_SERVICES_EVENTS,
  ...PASSWORD_STATE_EVENTS,
  ...CHANGE_PASSWORD_EVENTS,
  ...FORGOT_PASSWORD_EVENTS,
  ...RESET_PASSWORD_EVENTS,
  ...SET_UP_PASSWORD_EVENTS,
} as const;
